import React from 'react';
import { Input, FormLabel, FormControl, FormErrorMessage, useColorModeValue, Text } from '@chakra-ui/react';

export const DynamicInput = (
   name,
   label,
   props,
   errors = {},
   textColor = 'gray.700',
   inputType,
   isRequired = false,
   isDisabled = false,
   ref,
) => {
   const isFloating = props.value !== null && props.value !== undefined && props.value !== '';
   const isDateType = inputType === 'date';

   const backgroundColor = useColorModeValue('white', '#2d3748');
   const fontcolor = useColorModeValue('#333333', '#ffffff');

   const { nextRef, onKeyDown, ...restProps } = props;

   const handleKeyDown = (e) => {
      // if ((e.key === 'Enter' || e.key === 'Tab') && nextRef?.current) {
      //    e.preventDefault();
      //    nextRef.current.focus();
      // }

      // If user provided their own onKeyDown, call it too
      if (onKeyDown) {
         onKeyDown(e);
      }
   };

   return (
      <FormControl
         position="relative"
         // mt={6}
         isRequired={isRequired}>
         <Input
            id={name}
            name={name}
            placeholder={' '}
            type={inputType}
            isDisabled={isDisabled}
            isRequired={isRequired}
            borderRadius="md"
            borderColor="gray.300"
            paddingTop={1}
            // height="auto"
            textColor={fontcolor}
            paddingBottom="0.25rem"
            ref={ref}
            onKeyDown={handleKeyDown}
            {...restProps}
         />
         <FormLabel
            htmlFor={name}
            position="absolute"
            top={isFloating || isDateType ? '-8px' : '8px'}
            left="0.75rem"
            fontSize={
               isFloating || isDateType
                  ? { base: '10px', md: '12px', xl: '12px' } // floating: small
                  : { base: '12px', md: '16px', xl: '16px' } // normal: bigger
            }
            color={textColor}
            pointerEvents="none"
            padding={0}
            backgroundColor={backgroundColor}
            px="1"
            transition="all 0.2s ease-in-out"
            zIndex={10}>
            {label}
         </FormLabel>
         {errors[name] && (
            <Text color="red.500" fontSize="sm" mt="2">
               {errors[name]}
            </Text>
         )}
      </FormControl>
   );
};
